module.exports = __webpack_public_path__ + "img/calendar-item.5f927c66.svg";